<template>
	<div class="flex flex-wrap py-2 border-t border-t-dj-gray-light border-b border-b-dj-gray-light">
		<DjCardTag
			v-for="(tag, index) in vsblTags"
			:key="index"
			:bordered="index === 0 || index === 2 ? true : false"
			:class="index === 1 ? 'basis-2/3 bg-yellow' : ''"
		>
			<span class="whitespace-nowrap">{{ tag }}</span>
		</DjCardTag>
		<DjCardTag v-if="rmnTags.length > 0">
			<BaseTooltip :title="rmnTags.join(' | ')" class="px-2 py-1 bg-dj-gray-minimal rounded-big -mt-2 -mb-2">
				+{{ rmnTags.length }}
			</BaseTooltip>
		</DjCardTag>
	</div>
</template>

<script lang="ts">
import DjCardTag from "~/ui-kit/components/card/partials/DjCardTag.vue";
import BaseTooltip from "~/ui-kit/components/BaseTooltip.vue";

import { defineComponent, computed } from "vue";
import type { TagObject } from "~/ui-kit/types/types";

export default defineComponent({
	name: "DjCardJobTags",
	components: {
		DjCardTag,
		BaseTooltip,
	},
	props: {
		tags: {
			type: Object,
			default: () => {
				return {};
			},
		},
		lang: {
			type: String,
			default: "hu",
		},
		visibleTags: {
			type: Number,
			default: 999,
		},
	},
	setup(props) {
		const mergedTags = computed<string[]>(() => {
			const result: string[] = [];

			Object.values(props.tags).forEach((tag: TagObject) => {
				if (tag.data) {
					tag.data.forEach((tagObj: TagObject) => {
						Object.entries(tagObj.name).forEach((ele) => {
							if (ele[0] === props.lang) result.push(ele[1]);
						});
					});
				} else {
					Object.entries(tag.name).forEach((ele) => {
						if (ele[0] === props.lang) result.push(ele[1]);
					});
				}
			});

			return result;
		});

		const vsblTags = computed(() => mergedTags.value.slice(0, props.visibleTags));
		const rmnTags = computed(() => mergedTags.value.slice(props.visibleTags));

		return {
			vsblTags,
			rmnTags,
		};
	},
});
</script>
